import React, { useState } from 'react';
import './Header.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="container">
        <div className="nav">
            <div className="logo">
              <img src="/Logo.png" alt="Wadi empire and builds Ltd" className="logo-img" />
              <span>Wadi empire and builds Ltd</span>
            </div>
            <nav className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
              <a href="#home">Home</a>
              <a href="#services">Services</a>
              <a href="#about">About</a>
              <a href="#contact">Contact</a>
            </nav>
          
          <button 
            className="menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;